
<template>
	<div class="headder">
		<div class="head-cont clear">
			<div class="logo-lk fl">
				<a :href="BASE_URL" class="logo-c">
					<img v-if="logo_url" :src="BASE_URL + logo_url" alt="logo">
					<!-- <img v-else src="../../../../public/logo.png" alt="logo"> -->
				</a>
				<a v-if="logo_txt" :href="BASE_URL" class="logo-txt">{{logo_txt}}</a>
				<i>·</i>
				<a :href="BASE_URL" >个人主页</a>
				<!-- <router-link :to="{path: '/space/video', query: {id: this.$route.query.id}}" class="link-home">个人空间</router-link> -->
			</div>
		</div>
	</div>
</template>

<script>
	
	export default{
		data(){
			return {
				baseUrl: process.env.BASE_URL,
				logo_url: sessionStorage.getItem('logoUrl'),
				logo_txt: sessionStorage.getItem('logoTxt')
			}
		},
		watch: {

		},
		created(){
		},
		methods: {

		}
	}
</script>

<style lang="scss">
	.headder{
		background: #fff;
		height: 80px;
		box-shadow: 0 2px 4px 0 rgba(195,195,195,0.30);
	}
	.head-cont{
		padding: 15px 25px 0 25px;
	}
	.logo-c{
		display: inline-block;
		vertical-align: top;
		max-width: 180px;
		height: 40px;
		overflow: hidden;
		>img{
			width: 100%;
			// max-height: 40px;
		}
		>span{
			font-size: 22px;
			margin: 0 5px 0 10px;
			font-weight: bold;
		}
	}
	.logo-lk{
		>a{
			line-height: 40px;
			font-size: 16px;
		}
		>i{
			margin: 0 5px;
			font-weight: bold;
		}
		.link-home{
			font-size: 16px;
			color: #000000;
			letter-spacing: 2px;

		}
	}

	.train-test{
		button{
			background: #348EFC;
			border-radius: 3px;
			width: 120px;
			height: 36px;
			line-height: 36px;
			text-align: center;
			color: #fff;
			padding: 0;
		}
		>a,>span{
			display: inline-block;
			vertical-align: top;
			line-height: 36px;
			color: #338efc;
			margin-right: 30px;
			cursor: pointer;
		}
	}
</style>